import styled, { css } from 'styled-components'

export type TButtonColor = 'primary' | 'secondary' | 'tertiary' | 'danger'
export type TButtonVariant = 'contained' | 'outlined'

const buttonVariant = (color: TButtonColor) => {
    if (color === 'secondary')
        return css`
            background-color: #000;
            color: #fff;

            &:hover {
                background-color: #000000d4;
            }

            &:active {
                border: 1px solid rgba(255, 255, 255, 0.1);
                box-shadow: none;
            }
        `

    if (color === 'tertiary')
        return css`
            background-color: #846cf6;
            color: #fff;

            &:hover {
                background-color: #846cf6d4;
            }

            &:active {
                border: 1px solid rgba(132, 108, 246, 0.1);
                box-shadow: none;
            }
        `

    if (color === 'danger')
        return css`
            background-color: #ffffff;
            color: #f27373;
            border: 1px solid #f27373;

            &:hover {
                background-color: #f2737309;
            }

            &:active {
                box-shadow: none;
            }
        `

    return css`
        background-color: #ffffff;
        color: #000;

        &:hover {
            background-color: #fafafa;
        }

        &:active {
            border: 1px solid rgba(0, 0, 0, 0.1);
            box-shadow: none;
        }
    `
}

export const ButtonStyled = styled.button<{ color: TButtonColor; circle?: boolean; fullWidth?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    height: 40px;
    padding: 0px 12px 0px 12px;
    box-shadow: 0px 0.6px 1.56px -0.66px rgba(0, 0, 0, 0.1), 0px 2.29px 5.95px -1.33px rgba(0, 0, 0, 0.11145),
        0px 10px 26px -2px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    border: none;

    ${properties => properties.fullWidth && `width: 100%;`}
    ${properties => properties.circle && `border-radius: 100px;`}
    ${properties => buttonVariant(properties.color)}
`
